
import { defineComponent } from 'vue';
import { MatomoUrl, Alert } from 'CoreHome';

export default defineComponent({
  components: {
    Alert,
  },
  props: {
    provider: {
      type: Object,
      required: true,
    },
  },
  computed: {
    configureUrl() {
      return `?${MatomoUrl.stringify({
        ...MatomoUrl.urlParsed.value,
        action: `configure${this.provider.id}`,
      })}`;
    },
  },
});
